import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Dotdotdot } from "../../../dotdotdot/src";
import { DefaultLink, Link } from "../../../link/src";
export const Description = ({ description, href, isInternalLink, providerUrl, title, withTitleSpacer, }) => (_jsxs(Box, { flexDirection: "column", position: "relative", px: 3, py: 4, children: [title && (_jsx(Title, { mb: 1, pr: withTitleSpacer ? 10 : 0, children: _jsx(Dotdotdot, { clamp: 2, children: isInternalLink && href ? (_jsx(Link, { styledOnlyOnHover: true, to: href, children: title })) : (_jsx(DefaultLink, { href: href, styledOnlyOnHover: true, target: "_blank", children: title })) }) })), providerUrl && (_jsx(UpperCaseBox, { font: "body-regular-dove", children: _jsx(Dotdotdot, { clamp: 1, children: providerUrl }) })), description && (_jsx(Box, { mt: 2, children: _jsx(Dotdotdot, { clamp: 3, children: description }) }))] }));
const Title = styled(Box).attrs({
    display: 'block',
    fontWeight: 1,
}) ``;
const UpperCaseBox = styled(Box) `
  /* text-transform: uppercase; */
`;
//# sourceMappingURL=Description.js.map